/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var CityPersonOutlineIcon = function CityPersonOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M8 16V14H6V16H8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 6H12V20H14.295C14.1727 20.6924 14.2759 21.3916 14.5553 22L5 21.9999C3.34315 21.9999 2 20.6568 2 18.9999V12.207C2 11.8092 2.15804 11.4277 2.43934 11.1464L7 6.58569L10 9.58569V4H20L20 11C19.2714 11 18.5883 11.1948 18 11.5351V6ZM7 9.41412L10 12.4141V19.9999H8V18H6V19.9999H5C4.44772 19.9999 4 19.5522 4 18.9999V12.4141L7 9.41412Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4672 21.3375C16.2206 20.9567 16.1612 20.4541 16.3775 20C16.407 19.938 16.4416 19.877 16.4816 19.8172C16.8596 19.2529 17.3843 18.7935 18 18.4777L18.0118 18.4717C18.6069 18.1689 19.2863 18 20 18C20.7137 18 21.3931 18.1689 21.9882 18.4717L22.0267 18.4915C22.6309 18.8068 23.1459 19.2611 23.5184 19.8172C23.56 19.8794 23.5959 19.943 23.6261 20.0076C23.8382 20.4597 23.778 20.9588 23.5328 21.3375C23.2672 21.7476 22.8035 22 22.2982 22H17.7018C17.1965 22 16.7328 21.7476 16.4672 21.3375Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 17C20.6213 17 21.1765 16.7167 21.5433 16.2722C21.5625 16.2489 21.5812 16.2252 21.5993 16.2011C21.8509 15.8666 22 15.4507 22 15C22 14.0335 21.3144 13.2271 20.4031 13.0406C20.2729 13.014 20.1381 13 20 13C18.8954 13 18 13.8954 18 15C18 15.4507 18.1491 15.8666 18.4007 16.2011C18.7656 16.6862 19.3462 17 20 17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 8H16V10H14V8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12H16V14H14V12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 16H16V18H14V16Z"
  }));
};
export default CityPersonOutlineIcon;